module.exports = __webpack_public_path__ + "fonts/NunitoSans_10pt-Medium.ca8fff2e.ttf";